export const UPDATE_LICENSE_REQUEST = "update/license/request";
export const UPDATE_LICENSE_SUCCESS = "update/license/success";
export const UPDATE_LICENSE_FAILURE = "update/license/failure";

export const REDEEM_CODE_REQUEST = "redeem/code/request";
export const REDEEM_CODE_SUCCESS = "redeem/code/success";
export const REDEEM_CODE_FAILURE = "redeem/code/failure";
